export class WordsParse {
  /***
   * 平假名转片假名
   */
  static hiraToKana (str) {
    return str.replace(/[\u3041-\u3096]/g, function (match) {
      const chr = match.charCodeAt(0) + 0x60
      return String.fromCharCode(chr)
    })
  }
  /**
   * 全角转半角
   */
  static zenkakuToHankaku (mae) {
    // eslint-disable-next-line no-array-constructor
    let zen = new Array(
      'ア', 'イ', 'ウ', 'エ', 'オ', 'カ', 'キ', 'ク', 'ケ', 'コ'
      , 'サ', 'シ', 'ス', 'セ', 'ソ', 'タ', 'チ', 'ツ', 'テ', 'ト'
      , 'ナ', 'ニ', 'ヌ', 'ネ', 'ノ', 'ハ', 'ヒ', 'フ', 'ヘ', 'ホ'
      , 'マ', 'ミ', 'ム', 'メ', 'モ', 'ヤ', 'ヰ', 'ユ', 'ヱ', 'ヨ'
      , 'ラ', 'リ', 'ル', 'レ', 'ロ', 'ワ', 'ヲ', 'ン'
      , 'ガ', 'ギ', 'グ', 'ゲ', 'ゴ', 'ザ', 'ジ', 'ズ', 'ゼ', 'ゾ'
      , 'ダ', 'ヂ', 'ヅ', 'デ', 'ド', 'バ', 'ビ', 'ブ', 'ベ', 'ボ'
      , 'パ', 'ピ', 'プ', 'ペ', 'ポ'
      , 'ァ', 'ィ', 'ゥ', 'ェ', 'ォ', 'ャ', 'ュ', 'ョ', 'ッ'
      , '゛', '°', '、', '。', '「', '」', 'ー', '・'
    )
    // eslint-disable-next-line no-array-constructor
    let han = new Array(
      'ｱ', 'ｲ', 'ｳ', 'ｴ', 'ｵ', 'ｶ', 'ｷ', 'ｸ', 'ｹ', 'ｺ'
      , 'ｻ', 'ｼ', 'ｽ', 'ｾ', 'ｿ', 'ﾀ', 'ﾁ', 'ﾂ', 'ﾃ', 'ﾄ'
      , 'ﾅ', 'ﾆ', 'ﾇ', 'ﾈ', 'ﾉ', 'ﾊ', 'ﾋ', 'ﾌ', 'ﾍ', 'ﾎ'
      , 'ﾏ', 'ﾐ', 'ﾑ', 'ﾒ', 'ﾓ', 'ﾔ', 'ｲ', 'ﾕ', 'ｴ', 'ﾖ'
      , 'ﾗ', 'ﾘ', 'ﾙ', 'ﾚ', 'ﾛ', 'ﾜ', 'ｦ', 'ﾝ'
      , 'ｶﾞ', 'ｷﾞ', 'ｸﾞ', 'ｹﾞ', 'ｺﾞ', 'ｻﾞ', 'ｼﾞ', 'ｽﾞ', 'ｾﾞ', 'ｿﾞ'
      , 'ﾀﾞ', 'ﾁﾞ', 'ﾂﾞ', 'ﾃﾞ', 'ﾄﾞ', 'ﾊﾞ', 'ﾋﾞ', 'ﾌﾞ', 'ﾍﾞ', 'ﾎﾞ'
      , 'ﾊﾟ', 'ﾋﾟ', 'ﾌﾟ', 'ﾍﾟ', 'ﾎﾟ'
      , 'ｧ', 'ｨ', 'ｩ', 'ｪ', 'ｫ', 'ｬ', 'ｭ', 'ｮ', 'ｯ'
      , 'ﾞ', 'ﾟ', '､', '｡', '｢', '｣', 'ｰ', '･'
    )

    let ato = ''

    for (let i = 0; i < mae.length; i++) {
      let maechar = mae.charAt(i)
      let zenindex = zen.indexOf(maechar)
      if (zenindex >= 0) {
        maechar = han[zenindex]
      }
      ato += maechar
    }

    return ato
  }

  static jpUpCaser (str) {
    var dicts = [['ヮ', 'ﾜ'],
      ['ｧ', 'ｱ'],
      ['ｨ', 'ｲ'],
      ['ｩ', 'ｳ'],
      ['ｪ', 'ｴ'],
      ['ｫ', 'ｵ'],
      ['ｬ', 'ﾔ'],
      ['ｭ', 'ﾕ'],
      ['ｮ', 'ﾖ'],
      ['ｯ', 'ﾂ']]
    for (let index = 0; index < dicts.length; index++) {
      const dict = dicts[index]
      str = str.replace(new RegExp(dict[0], 'gm'), dict[1])
    }
    return str
  }

  /**
   * 字母&数字全角转半角
   * @param {*} str
   */
  static ToCDB (str) {
    let tmp = ''
    for (let i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 65248 && str.charCodeAt(i) < 65375) {
        tmp += String.fromCharCode(str.charCodeAt(i) - 65248)
      } else {
        tmp += String.fromCharCode(str.charCodeAt(i))
      }
    }
    return tmp.toLocaleUpperCase()
  }

  static parse (str) {
    str = this.hiraToKana(str)
    str = this.zenkakuToHankaku(str)
    str = this.jpUpCaser(str)
    str = this.ToCDB(str)
    return str
  }
}
